import { useTranslations } from 'next-intl';

const useFirebaseErrors = () => {
  const tFirebaseErrors = useTranslations('FirebaseErrors');

  const MAPPING_RESETPASSWORD_ERROR = {
    'auth/invalid-email': tFirebaseErrors('ResetPassword.invalidEmail'),
    'auth/user-not-found': tFirebaseErrors('ResetPassword.userNotFound'),
  };

  const MAPPING_SIGIN_ERROR = {
    'auth/invalid-email': tFirebaseErrors('SignIn.invalidEmail'),
    'auth/user-not-found': tFirebaseErrors('SignIn.userNotFound'),
    'auth/wrong-password': tFirebaseErrors('SignIn.wrongPassword'),
    'auth/too-many-requests': tFirebaseErrors('SignIn.tooManyRequests'),
  };

  const MAPPING_CREATEUSER_ERROR = {
    'auth/email-already-in-use': tFirebaseErrors('CreateUser.emailAlreadyUsed'),
  };

  const MAPPING_UPDATEUSER_ERROR = {
    'auth/requires-recent-login': tFirebaseErrors(
      'UpdateUser.reconnectionNeeded',
    ),
    'auth/email-already-in-use': tFirebaseErrors('UpdateUser.emailAlreadyUsed'),
    'auth/email-already-exists': tFirebaseErrors(
      'UpdateUser.emailAlreadyExists',
    ),
  };

  return {
    MAPPING_RESETPASSWORD_ERROR,
    MAPPING_SIGIN_ERROR,
    MAPPING_CREATEUSER_ERROR,
    MAPPING_UPDATEUSER_ERROR,
  };
};

export default useFirebaseErrors;
